import type { Session } from '@supabase/supabase-js';
import { error, redirect } from '@sveltejs/kit';

export type NFTPathParams =
	| {
			unit: string;
	  }
	| {
			policyId: string;
			assetNameHex: string;
	  };
export const nftPath = (params: NFTPathParams) => {
	// we could add a check here that it's a valid assetId/policyId/tokenName
	// but that check happens at the page and will 404 if the values are bad
	// If we ever want to validate *before* the user clicks the link, this would be the best place to do it.
	if ('unit' in params && params.unit) {
		return `/nfts/${params.unit}`;
	} else if ('policyId' in params && 'assetNameHex' in params) {
		return `/nfts/${params.policyId}${params.assetNameHex}`;
	}
};

export const PROXIED_BLOCKFROST_URL = '/blockfrost';
